function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.0938 0C12.7969 0 13.4062 0.375 13.7344 0.984375L23.8594 19.7344C24.1875 20.2969 24.1875 21 23.8125 21.6094C23.4844 22.1719 22.875 22.5 22.2188 22.5H1.96875C1.3125 22.5 0.703125 22.1719 0.375 21.6094C0 21 0 20.2969 0.328125 19.7344L10.4531 0.984375C10.7812 0.375 11.3906 0 12.0938 0ZM12.0938 16.5C11.25 16.5 10.5938 17.1562 10.5938 18C10.5938 18.8438 11.25 19.5 12.0938 19.5C12.9375 19.5 13.5938 18.8438 13.5938 18C13.5938 17.1562 12.9375 16.5 12.0938 16.5ZM12.0938 7.5C11.25 7.5 10.5469 8.25 10.6406 9.09375L10.9688 13.9688C11.0156 14.5312 11.4844 15 12.0938 15C12.7031 15 13.1719 14.5312 13.2188 13.9688L13.5469 9.09375C13.6406 8.25 12.9375 7.5 12.0938 7.5Z",
  fill: "#F9A825"
});

function SvgPhishingManagerWarningModal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 23,
    viewBox: "0 0 25 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      width: "24px,height:24px"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhishingManagerWarningModal);
export default __webpack_public_path__ + "static/media/phishing-manager-warning-modal.58e1250a.svg";
export { ForwardRef as ReactComponent };